import React, { useState, useEffect } from 'react';
// Storm panel v2 - with dates, hail sizes, state filter

const PROPERTY_API_URL = 'https://property-lookup-api.anassk.workers.dev';
const PROPERTY_API_KEY = '19285196e984c67c9c96784becbd3464e692815a4393e4c948be460a2019182e';

// Custom marker icons for storm events (SVG files in /public/markers/)
export const STORM_MARKERS = {
  hail: '/markers/hail.svg',
  wind: '/markers/wind.svg',
  tornado: '/markers/tornado.svg'
};

// Quick navigation links for storm zones and wealthy areas with NOAA report references
const QUICK_LINKS = [
  // Storm zones with NOAA verified coordinates
  { name: 'Southport', lat: 39.65, lng: -86.04, note: '1.00" hail May 20, 2025 (mPING verified)', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/250520_rpts.html' },
  { name: 'New Whiteland', lat: 39.54, lng: -86.10, note: '1.00" hail May 16, 2025', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/250516_rpts.html' },
  { name: 'Brownsburg', lat: 39.83, lng: -86.44, note: 'EF-2 Tornado Apr 2, 2025 - 20+ homes', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws: 'https://www.weather.gov/ind/april_02_2025_severe' },
  { name: 'Carmel', lat: 39.96, lng: -86.15, note: 'EF-1 Tornado Apr 2, 2025', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws: 'https://www.weather.gov/ind/april_02_2025_severe' },
  { name: 'Lapel', lat: 40.19, lng: -85.59, note: 'EF-2 Tornado Apr 2, 2025 - 15mi path', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws: 'https://www.weather.gov/ind/april_02_2025_severe' },
  { name: 'Loogootee', lat: 38.67, lng: -86.91, note: '2.00" golf ball hail Apr 30, 2025', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/250430_rpts.html' },
  { name: 'Lake Village', lat: 41.12, lng: -87.51, note: 'Fatal tornado Mar 10, 2026 - 5 tornadoes', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', nws: 'https://www.weather.gov/lot/2026_03_10_Severe_Weather' },
  { name: 'Hobart', lat: 41.53, lng: -87.25, note: '1" hail Mar 10, 2026', type: 'storm', noaa: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html' },
  // Wealthy areas
  { name: 'Carmel $', lat: 39.978, lng: -86.118, note: '$125K median income', type: 'wealthy' },
  { name: 'Geist', lat: 39.915, lng: -85.961, note: '$107K income + Storm track', type: 'wealthy' },
  { name: 'Eagle Creek', lat: 39.89, lng: -86.30, note: '$148K income + 70mph wind Apr 2', type: 'wealthy', noaa: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html' },
];

// Local Indiana storm data - NOAA SPC & NWS verified with official report links for insurance claims
// Sources: https://www.spc.noaa.gov/climo/reports/ & https://www.weather.gov/ind/
export const INDIANA_STORM_DATA = [
  // === HAIL REPORTS - NOAA SPC VERIFIED ===
  // May 20, 2025 - Marion County (CONFIRMED - mPING)
  { event_type: 'hail', latitude: 39.65, longitude: -86.04, event_date: '2025-05-20', comments: '1.00" hail - 4 E Southport (mPING)', county: 'Marion', state: 'IN', magnitude: 100, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250520_rpts.html', source: 'NOAA SPC' },
  // May 16, 2025 - Johnson County
  { event_type: 'hail', latitude: 39.54, longitude: -86.10, event_date: '2025-05-16', comments: '1.00" hail - 2 NW New Whiteland', county: 'Johnson', state: 'IN', magnitude: 100, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250516_rpts.html', source: 'NOAA SPC' },
  // April 30, 2025 - Southern Indiana (NOAA SPC verified)
  { event_type: 'hail', latitude: 38.68, longitude: -87.17, event_date: '2025-04-30', comments: '1.50" ping pong ball hail - Glendale', county: 'Daviess', state: 'IN', magnitude: 150, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250430_rpts.html', source: 'NOAA SPC' },
  { event_type: 'hail', latitude: 38.67, longitude: -86.91, event_date: '2025-04-30', comments: '2.00" golf ball hail - Loogootee', county: 'Martin', state: 'IN', magnitude: 200, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250430_rpts.html', source: 'NOAA SPC' },
  { event_type: 'hail', latitude: 38.72, longitude: -86.80, event_date: '2025-04-30', comments: '1.75" hail - Shoals', county: 'Martin', state: 'IN', magnitude: 175, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250430_rpts.html', source: 'NOAA SPC' },
  // April 29, 2025 - Greene County
  { event_type: 'hail', latitude: 39.08, longitude: -87.08, event_date: '2025-04-29', comments: '1.00" hail - Lyons', county: 'Greene', state: 'IN', magnitude: 100, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250429_rpts.html', source: 'NOAA SPC' },
  // April 2, 2025 - Marion County (NWS verified)
  { event_type: 'hail', latitude: 39.66, longitude: -86.01, event_date: '2025-04-02', comments: '0.25" hail - 6 SE Beech Grove', county: 'Marion', state: 'IN', magnitude: 25, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  // March 14, 2025 - Southern Indiana (NOAA SPC verified)
  { event_type: 'hail', latitude: 38.21, longitude: -86.12, event_date: '2025-03-14', comments: '1.75" hail - Corydon', county: 'Harrison', state: 'IN', magnitude: 175, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250314_rpts.html', source: 'NOAA SPC' },
  { event_type: 'hail', latitude: 38.35, longitude: -87.57, event_date: '2025-03-14', comments: '1.75" hail - Princeton', county: 'Gibson', state: 'IN', magnitude: 175, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250314_rpts.html', source: 'NOAA SPC' },
  { event_type: 'hail', latitude: 38.12, longitude: -86.46, event_date: '2025-03-14', comments: '1.50" hail - Pilot Knob', county: 'Crawford', state: 'IN', magnitude: 150, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250314_rpts.html', source: 'NOAA SPC' },

  // === TORNADO REPORTS - NWS VERIFIED (April 2, 2025 Outbreak) ===
  { event_type: 'tornado', latitude: 39.83, longitude: -86.44, event_date: '2025-04-02', comments: 'EF-2 Brownsburg - 120mph, 9.57mi path, 20+ homes damaged', county: 'Hendricks', state: 'IN', magnitude: 2, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'tornado', latitude: 39.96, longitude: -86.15, event_date: '2025-04-02', comments: 'EF-1 Carmel - 105mph, 6.60mi path', county: 'Hamilton', state: 'IN', magnitude: 1, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'tornado', latitude: 40.19, longitude: -85.59, event_date: '2025-04-02', comments: 'EF-2 Lapel - 125mph, 15.15mi path', county: 'Madison', state: 'IN', magnitude: 2, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'tornado', latitude: 40.16, longitude: -85.61, event_date: '2025-04-02', comments: 'EF-0 Chesterfield - 85mph, 4.92mi path', county: 'Madison', state: 'IN', magnitude: 0, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'tornado', latitude: 40.25, longitude: -85.46, event_date: '2025-04-02', comments: 'EF-1 Muncie area - 100mph, 5.81mi path', county: 'Delaware', state: 'IN', magnitude: 1, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },

  // === WIND REPORTS - NWS VERIFIED (April 2, 2025 Outbreak) ===
  { event_type: 'wind', latitude: 39.89, longitude: -86.30, event_date: '2025-04-02', comments: '70mph - Power poles snapped, 3 N Eagle Creek', county: 'Marion', state: 'IN', magnitude: 70, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'wind', latitude: 39.72, longitude: -86.29, event_date: '2025-04-02', comments: '65mph gust - Indianapolis Airport (IND)', county: 'Marion', state: 'IN', magnitude: 65, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'wind', latitude: 39.64, longitude: -86.86, event_date: '2025-04-02', comments: '73mph measured - Greencastle', county: 'Putnam', state: 'IN', magnitude: 73, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'wind', latitude: 39.76, longitude: -86.53, event_date: '2025-04-02', comments: '81mph measured - Danville', county: 'Hendricks', state: 'IN', magnitude: 81, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'wind', latitude: 40.03, longitude: -85.51, event_date: '2025-04-02', comments: '87mph gust - Lapel', county: 'Madison', state: 'IN', magnitude: 87, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },
  { event_type: 'wind', latitude: 40.20, longitude: -85.35, event_date: '2025-04-02', comments: '100mph PWS - Eaton', county: 'Delaware', state: 'IN', magnitude: 100, noaa_report: 'https://www.spc.noaa.gov/climo/reports/250402_rpts.html', nws_report: 'https://www.weather.gov/ind/april_02_2025_severe', source: 'NWS Indianapolis' },

  // === MARCH 10, 2026 - NW INDIANA SEVERE OUTBREAK (Enhanced Risk - Level 3/5) ===
  // Sources: https://www.spc.noaa.gov/climo/reports/260310_rpts.html & https://www.weather.gov/lot/2026_03_10_Severe_Weather

  // TORNADO REPORTS - Fatal tornado family across Newton/Jasper/Starke counties
  { event_type: 'tornado', latitude: 41.12, longitude: -87.51, event_date: '2026-03-10', comments: 'Fatal tornado - Lake Village, 3 manufactured homes destroyed, 2 fatalities', county: 'Newton', state: 'IN', magnitude: 2, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', nws_report: 'https://www.weather.gov/lot/2026_03_10_Severe_Weather', source: 'NWS Chicago' },
  { event_type: 'tornado', latitude: 41.19, longitude: -87.01, event_date: '2026-03-10', comments: 'Tornado confirmed east of Wheatfield - spotter report', county: 'Jasper', state: 'IN', magnitude: 1, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', nws_report: 'https://www.weather.gov/lot/2026_03_10_Severe_Weather', source: 'NWS Chicago' },
  { event_type: 'tornado', latitude: 41.21, longitude: -86.92, event_date: '2026-03-10', comments: 'Tornado touchdown near San Pierre', county: 'Starke', state: 'IN', magnitude: 1, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', nws_report: 'https://www.weather.gov/lot/2026_03_10_Severe_Weather', source: 'NWS Chicago' },
  { event_type: 'tornado', latitude: 41.26, longitude: -86.79, event_date: '2026-03-10', comments: 'Tornado near English Lake - video confirmed', county: 'Starke', state: 'IN', magnitude: 1, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', nws_report: 'https://www.weather.gov/lot/2026_03_10_Severe_Weather', source: 'NWS Chicago' },
  { event_type: 'tornado', latitude: 41.30, longitude: -86.70, event_date: '2026-03-10', comments: 'Tornado near Toto - large trees downed', county: 'Starke', state: 'IN', magnitude: 1, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', nws_report: 'https://www.weather.gov/lot/2026_03_10_Severe_Weather', source: 'NWS Chicago' },

  // HAIL REPORTS - 1"+ hail across NW Indiana
  { event_type: 'hail', latitude: 41.21, longitude: -87.21, event_date: '2026-03-10', comments: '1.00" hail - DeMotte', county: 'Jasper', state: 'IN', magnitude: 100, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', source: 'NOAA SPC' },
  { event_type: 'hail', latitude: 41.53, longitude: -87.25, event_date: '2026-03-10', comments: '1.00" hail - Hobart', county: 'Lake', state: 'IN', magnitude: 100, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', source: 'NOAA SPC' },
  { event_type: 'hail', latitude: 41.58, longitude: -86.96, event_date: '2026-03-10', comments: '1.00" hail - Chesterton area', county: 'Porter', state: 'IN', magnitude: 100, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', source: 'NOAA SPC' },

  // WIND REPORTS - structural damage across NW Indiana
  { event_type: 'wind', latitude: 41.12, longitude: -87.45, event_date: '2026-03-10', comments: 'Structural damage, commercial signs down - Lake Village', county: 'Newton', state: 'IN', magnitude: 70, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', source: 'NWS Chicago' },
  { event_type: 'wind', latitude: 41.32, longitude: -86.72, event_date: '2026-03-10', comments: 'Barn destroyed, debris on Route 8 - Brems', county: 'Starke', state: 'IN', magnitude: 70, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', source: 'NWS Chicago' },
  { event_type: 'wind', latitude: 41.53, longitude: -85.78, event_date: '2026-03-10', comments: '59mph ASOS measurement - Benton', county: 'Elkhart', state: 'IN', magnitude: 59, noaa_report: 'https://www.spc.noaa.gov/climo/reports/260310_rpts.html', source: 'NOAA SPC' },
];

function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  // Format as "Jan 15, 2026"
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

// Generate NOAA SPC report URL from storm date
// Format: https://www.spc.noaa.gov/climo/reports/YYMMDD_rpts.html
function getNoaaReportUrl(dateStr) {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  const yy = String(date.getFullYear()).slice(-2);
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `https://www.spc.noaa.gov/climo/reports/${yy}${mm}${dd}_rpts.html`;
}

function getRelativeTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  return '';
}

function getStormIcon(type) {
  switch (type) {
    case 'hail': return '🧊';
    case 'wind': return '💨';
    case 'tornado': return '🌪️';
    default: return '⛈️';
  }
}

function getStormColor(type) {
  switch (type) {
    case 'hail': return '#f97316';
    case 'wind': return '#ef4444';
    case 'tornado': return '#9333ea';
    default: return '#6b7280';
  }
}

function StormZonesPanel({ isOpen, onClose, onGoToStorm, onSyncStorms }) {
  const [storms, setStorms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('all'); // all, hail, wind, tornado
  const [stateFilter, setStateFilter] = useState('IN'); // Default to Indiana

  // Fetch recent storms on open
  useEffect(() => {
    if (isOpen) {
      fetchRecentStorms();
    }
  }, [isOpen]);

  const fetchRecentStorms = async () => {
    setLoading(true);
    setError(null);

    try {
      // Fetch storms for entire US (broad area) - 90 days for better coverage
      const response = await fetch(
        `${PROPERTY_API_URL}/storms?minLat=25&maxLat=50&minLng=-130&maxLng=-65&days=90`,
        { headers: { 'X-API-Key': PROPERTY_API_KEY } }
      );

      const data = await response.json();

      // Start with local Indiana storm data (always include)
      let allStorms = [...INDIANA_STORM_DATA];

      if (data.success) {
        // Add API storms, filtering out small hail (< 0.75")
        const apiStorms = (data.storms || []).filter(storm => {
          if (storm.event_type === 'hail') {
            return (storm.magnitude || 0) >= 75; // 0.75" minimum
          }
          return true; // Keep all wind/tornado
        });

        // Merge API storms (avoid duplicates by checking location)
        apiStorms.forEach(apiStorm => {
          const isDuplicate = allStorms.some(local =>
            Math.abs(local.latitude - apiStorm.latitude) < 0.01 &&
            Math.abs(local.longitude - apiStorm.longitude) < 0.01 &&
            local.event_type === apiStorm.event_type
          );
          if (!isDuplicate) {
            allStorms.push(apiStorm);
          }
        });
      }

      // Group storms by state and date
      const grouped = {};
      allStorms.forEach(storm => {
        const key = `${storm.state}-${storm.event_date}`;
        if (!grouped[key]) {
          grouped[key] = {
            state: storm.state,
            date: storm.event_date,
            storms: [],
            center: { lat: storm.latitude, lng: storm.longitude }
          };
        }
        grouped[key].storms.push(storm);
        // Update center to average
        const storms = grouped[key].storms;
        grouped[key].center = {
          lat: storms.reduce((s, st) => s + st.latitude, 0) / storms.length,
          lng: storms.reduce((s, st) => s + st.longitude, 0) / storms.length
        };
      });

      // Convert to array and sort by date (most recent first)
      const stormGroups = Object.values(grouped).sort((a, b) =>
        new Date(b.date) - new Date(a.date)
      );

      setStorms(stormGroups);
    } catch (e) {
      // Even if API fails, show local Indiana data
      const grouped = {};
      INDIANA_STORM_DATA.forEach(storm => {
        const key = `${storm.state}-${storm.event_date}`;
        if (!grouped[key]) {
          grouped[key] = {
            state: storm.state,
            date: storm.event_date,
            storms: [],
            center: { lat: storm.latitude, lng: storm.longitude }
          };
        }
        grouped[key].storms.push(storm);
      });
      setStorms(Object.values(grouped).sort((a, b) => new Date(b.date) - new Date(a.date)));
      setError(null); // Don't show error since we have local data
    }

    setLoading(false);
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      const response = await fetch(`${PROPERTY_API_URL}/storms/sync`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': PROPERTY_API_KEY
        },
        body: JSON.stringify({ days: 30 })
      });

      const data = await response.json();

      if (data.success) {
        // Refresh the list
        await fetchRecentStorms();
        if (onSyncStorms) onSyncStorms(data);
      }
    } catch (e) {
      setError(e.message);
    }
    setSyncing(false);
  };

  const filteredStorms = storms.filter(group => {
    // State filter
    if (stateFilter !== 'all' && group.state !== stateFilter) return false;

    // Type filter - for hail, also check magnitude >= 75 (0.75")
    if (filter === 'all') return true;
    if (filter === 'hail') {
      return group.storms.some(s => s.event_type === 'hail' && (s.magnitude || 0) >= 75);
    }
    return group.storms.some(s => s.event_type === filter);
  });

  if (!isOpen) return null;

  return (
    <div className="storm-panel-overlay" onClick={onClose}>
      <div className="storm-panel" onClick={e => e.stopPropagation()}>
        <div className="storm-panel-header">
          <h2>⚡ Recent Storm Zones</h2>
          <button className="storm-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="storm-panel-toolbar">
          <div className="storm-filters">
            <select
              className="storm-state-select"
              value={stateFilter}
              onChange={(e) => setStateFilter(e.target.value)}
            >
              <option value="all">All States</option>
              <option value="IN">Indiana</option>
              <option value="IL">Illinois</option>
              <option value="OH">Ohio</option>
              <option value="MI">Michigan</option>
              <option value="KY">Kentucky</option>
              <option value="TX">Texas</option>
              <option value="OK">Oklahoma</option>
              <option value="KS">Kansas</option>
            </select>
            <button
              className={`storm-filter ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button
              className={`storm-filter ${filter === 'hail' ? 'active' : ''}`}
              onClick={() => setFilter('hail')}
              title="Hail ≥ 0.75 inch"
            >
              🧊 Hail
            </button>
            <button
              className={`storm-filter ${filter === 'wind' ? 'active' : ''}`}
              onClick={() => setFilter('wind')}
            >
              💨 Wind
            </button>
            <button
              className={`storm-filter ${filter === 'tornado' ? 'active' : ''}`}
              onClick={() => setFilter('tornado')}
            >
              🌪️ Tornado
            </button>
          </div>

          <button
            className="storm-sync-btn"
            onClick={handleSync}
            disabled={syncing}
          >
            {syncing ? '⏳ Syncing...' : '🔄 Sync NOAA'}
          </button>
        </div>

        {error && (
          <div className="storm-error">
            ⚠️ {error}
          </div>
        )}

        {/* Quick Links Section */}
        <div className="storm-quick-links">
          <div className="storm-quick-section">
            <span className="storm-quick-label">⚡ Storm Zones:</span>
            {QUICK_LINKS.filter(l => l.type === 'storm').map((link, i) => (
              <button
                key={i}
                className="storm-quick-btn"
                onClick={() => {
                  onGoToStorm({ lat: link.lat, lng: link.lng }, { state: 'IN', storms: [{ county: link.name }] });
                  onClose();
                }}
                title={link.note}
              >
                {link.name}
              </button>
            ))}
          </div>
          <div className="storm-quick-section">
            <span className="storm-quick-label">💰 Wealthy:</span>
            {QUICK_LINKS.filter(l => l.type === 'wealthy').map((link, i) => (
              <button
                key={i}
                className="storm-quick-btn wealthy"
                onClick={() => {
                  onGoToStorm({ lat: link.lat, lng: link.lng }, { state: 'IN', storms: [{ county: link.name }] });
                  onClose();
                }}
                title={link.note}
              >
                {link.name}
              </button>
            ))}
          </div>
        </div>

        <div className="storm-list">
          {loading ? (
            <div className="storm-loading">
              <span className="spinner"></span>
              Loading storm data...
            </div>
          ) : filteredStorms.length === 0 ? (
            <div className="storm-empty">
              <div className="storm-empty-icon">🌤️</div>
              <p>No recent storms found</p>
              <p className="storm-empty-hint">Click "Sync NOAA" to fetch latest data</p>
            </div>
          ) : (
            filteredStorms.map((group, index) => {
              const hailStorms = group.storms.filter(s => s.event_type === 'hail' && (s.magnitude || 0) >= 75);
              const maxHailSize = Math.max(...hailStorms.map(s => s.magnitude || 0), 0);
              const windCount = group.storms.filter(s => s.event_type === 'wind').length;
              const maxWindSpeed = Math.max(...group.storms.filter(s => s.event_type === 'wind').map(s => s.magnitude || 0), 0);
              const tornadoCount = group.storms.filter(s => s.event_type === 'tornado').length;

              return (
                <div
                  key={index}
                  className="storm-item"
                  onClick={() => {
                    onGoToStorm(group.center, group);
                    onClose();
                  }}
                >
                  <div className="storm-item-header">
                    <span className="storm-state">{group.state} - {group.storms[0]?.county || 'Unknown'}</span>
                    <span className="storm-date">
                      {formatDate(group.date)}
                      {getRelativeTime(group.date) && <span className="storm-relative"> ({getRelativeTime(group.date)})</span>}
                    </span>
                  </div>

                  <div className="storm-item-stats">
                    {hailStorms.length > 0 && (
                      <span className="storm-stat hail" title={`${hailStorms.length} hail damage reports, largest hail ${(maxHailSize / 100).toFixed(2)} inches`}>
                        🧊 {hailStorms.length} reports • {(maxHailSize / 100).toFixed(2)}" hail
                      </span>
                    )}
                    {windCount > 0 && (
                      <span className="storm-stat wind" title={`${windCount} wind damage reports, max wind speed ${maxWindSpeed} mph`}>
                        💨 {windCount} reports • max {maxWindSpeed} mph
                      </span>
                    )}
                    {tornadoCount > 0 && (
                      <span className="storm-stat tornado" title={`${tornadoCount} tornado reports`}>
                        🌪️ {tornadoCount} tornado{tornadoCount > 1 ? 's' : ''}
                      </span>
                    )}
                  </div>

                  {/* NOAA Report Links for Insurance - always show */}
                  {(() => {
                    // Get NOAA links from storms, or generate from date
                    const existingNoaa = [...new Set(group.storms.filter(s => s.noaa_report).map(s => s.noaa_report))];
                    const nwsLinks = [...new Set(group.storms.filter(s => s.nws_report).map(s => s.nws_report))];
                    // If no existing NOAA link, generate one from the date
                    const noaaLinks = existingNoaa.length > 0 ? existingNoaa : [getNoaaReportUrl(group.date)];
                    return (
                      <div className="storm-item-reports" onClick={e => e.stopPropagation()}>
                        <span className="reports-label">NOAA Report:</span>
                        {noaaLinks.filter(Boolean).map((url, i) => (
                          <a key={`noaa-${i}`} href={url} target="_blank" rel="noopener noreferrer" className="report-link noaa">
                            View SPC Report
                          </a>
                        ))}
                        {nwsLinks.map((url, i) => (
                          <a key={`nws-${i}`} href={url} target="_blank" rel="noopener noreferrer" className="report-link nws">
                            NWS Summary
                          </a>
                        ))}
                      </div>
                    );
                  })()}

                  <div className="storm-item-action">
                    <span className="go-to-btn">Go to area →</span>
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="storm-panel-footer">
          <p>💡 Click a storm zone to navigate there and find leads</p>
        </div>
      </div>
    </div>
  );
}

export default StormZonesPanel;
